import lazyComponent from '../../../utils/lazyComponent';
import { SnackbarsContainerProps } from './Snackbars';

const LazySnackbars = lazyComponent<SnackbarsContainerProps>(
  () => import('./Snackbars')
);

export default LazySnackbars;
